<template>
  <div class="container" v-loading.fullscreen.lock="fullscreen">
    <el-row :gutter="10">
      <el-col :md="12" :lg="10" :xl="8">
        <filterWrapper
          :filter-item="{ eatery: true, canteen: true, searchBox: true }"
        ></filterWrapper>
      </el-col>
      <el-col :span="6">
        <div class="btn-wrapper">
          <el-badge :value="count" class="item">
            <el-button type="primary" @click="batchAddImages" size="mini"
              >用于回测</el-button>
            <el-button type="primary" @click="addImagesForRegion" size="mini"
              >用于图框检测</el-button>
          </el-badge>
        </div>
      </el-col>
    </el-row>
    <el-upload
      class="upload-demo"
      drag
      action=""
      :file-list="markImageList"
      multiple
      list-type="picture-card"
      :http-request="handleIploadMarkImage"
      :on-remove="deleteImage"
    >
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__text">请注意，切割接口处理图片时间大约4s。</div>
      <div class="img-wrapper"></div>
    </el-upload>
    <!--<el-button class="back-top" type="primary" @click="backToTop">up</el-button>-->
  </div>
</template>
<script>
import {apiBatchAddImages, apiImageUploadForRegion} from '@/api';
import md5 from 'js-md5';
import aliUpload from '@/lib/aliOSSUpload';
import {mapGetters, mapMutations} from 'vuex';
import filterWrapper from '@/components/filterWrapper';

export default {
  name: "",
  components: {
    filterWrapper
  },
  data() {
    return {
      fullscreen: false,
      markImageList: []
    };
  },
  mounted() {
    this.setSubTitle("批量上传");
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    backToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    deleteImage(file, fileList) {
      console.log(fileList);
      this.markImageList = fileList;
    },
    handleIploadMarkImage(option) {
      // this.markImageList.push(option.file)
      this.fullscreen = true;
      let file = option.file;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      let that = this;
      fileReader.onload = async e => {
        let md5key = md5(e.target.result);
        aliUpload(
          {
            bucket: "big-image-uplaod"
          },
          file
        )
          .then(res => {
            that.markImageList.push({
              url: res.url,
              md5: md5key
            });
            this.fullscreen = false;
          })
          .catch(e => {
            console.log(e);
            this.fullscreen = false;
          });
      };
    },
    batchAddImages() {
      let that = this;
      this.fullscreen = true;

      apiBatchAddImages({
        apiKey: this.userinfo.api_key,
        imgList: this.markImageList,
        canteenId: this.listQuery.canteen.canteen_id
      })
        .then(res => {
          this.fullscreen = false;
          if (res.state_code === 0) {
            this.addMarkImageShow = false;
            let result = {
              duplicated:
                res.duplicated && res.duplicated.length
                  ? res.duplicated.length
                  : 0
            };
            if (result.duplicated !== 0) {
              that.$message({
                message: `${result.duplicated}张图片与数据库重复, 未上传`,
                type: "error"
              });
            } else {
              that.$message({
                message: `上传成功`,
                type: "success"
              });
            }
            that.markImageList = [];
          }
        })
        .catch(e => {
          this.fullscreen = false;
          console.log(e);
        });
    },
    async addImagesForRegion() {
      // let markImageList = this.$_.cloneDeep(this.markImageList
      try {
        await apiImageUploadForRegion({
          image_list: this.markImageList.map(a => {
            return {
              dish_img_url: a.url,
              img_md5: a.md5
            };
          }),
          source: 3,
          canteen_id: this.listQuery.canteen.canteen_id.toString()
        });
        this.$message.warning("上传成功");
        this.markImageList = [];
      } catch (e) {
        this.$message.error("上传失败" + e.message);
      }
    }
  },
  computed: {
    count() {
      return this.markImageList.length;
    },
    userinfo() {
      return this.$store.getters.userinfo();
    },
    ...mapGetters(["listQuery"])
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .btn-wrapper {
    position: relative;
    top: 5px;
  }
  .upload-demo {
    position: relative;
    .el-upload {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .back-top {
    position: fixed;
    bottom: 10vh;
    right: 10vw;
  }
}
</style>
